// Hand-rolled bridge from specs/seeds/dashboard-v2/wizards/campaign-create.yaml
// (CHG-1241 / ITER-3364) → typed TS constant.
//
// Per feedback_deterministic_codegen_over_hand_rolling.md: documented
// hand-rolled exception. Same posture as src/generated/settings-sections.ts
// (CHG-1239). The v2 FE generator will emit this from the YAML.

import type { WizardManifest } from "../../wizards/manifestTypes";

export const campaignCreateManifest: WizardManifest = {
  wizard_id: "campaign-create",
  version: "1.0.0",
  spec_id: "experience.cross-screen.campaign-create-v2",
  title: "New campaign",
  subtitle: "Set up a fundraising drive in 4 steps.",
  shape: "modal-wizard",
  size: "lg",
  persistence_key: "campaign-create",
  trigger: {
    permission: "alora-giving.campaign.create",
    invocation: [
      { from_route: "/campaigns", button: "New campaign" },
      { from_route: "/", button: "Create campaign" },
    ],
  },
  field_type_coverage: {
    canonical: ["designation_picker", "rich_text", "amount", "currency_picker", "date", "file_upload", "color"],
    pending_primitive: ["text"],
    custom_renders: [],
  },
  steps: [
    {
      step_id: "basics",
      label: "Basics",
      description: "Name and describe the campaign; pick the designation it funds.",
      fields: [
        { name: "name", type: "text", label: "Campaign name", required: true, pending_primitive: true, props: { max_length: 120 } },
        { name: "designation_id", type: "designation_picker", label: "Designation", required: true },
        { name: "description", type: "rich_text", label: "Description", props: { max_length: 2000 } },
      ],
    },
    {
      step_id: "goal",
      label: "Goal",
      description: "Set the fundraising target and timeline.",
      fields: [
        { name: "goal_amount_minor_units", type: "amount", label: "Goal amount", required: true },
        { name: "currency", type: "currency_picker", label: "Currency", required: true },
        { name: "end_date", type: "date", label: "Campaign end" },
      ],
    },
    {
      step_id: "brand",
      label: "Brand",
      description: "Optional cover image and theme color.",
      optional: true,
      fields: [
        { name: "cover_asset_id", type: "file_upload", label: "Cover image", props: { accept: "image/*" } },
        { name: "theme_color", type: "color", label: "Theme color" },
      ],
    },
    {
      step_id: "review",
      label: "Review",
      description: "Confirm the details and publish the campaign.",
      fields: [],
    },
  ],
  on_submit: {
    api_endpoint: "POST /campaigns",
    on_success: { redirect: "/campaigns/{response.id}" },
    on_error: { show_in_step: true },
  },
  validation: [
    { step_id: "basics", field: "name", rule: "not_empty" },
    { step_id: "basics", field: "name", rule: "max_length_120" },
    { step_id: "basics", field: "designation_id", rule: "not_empty" },
    { step_id: "goal", field: "goal_amount_minor_units", rule: "gt_zero" },
    { step_id: "goal", field: "currency", rule: "iso_4217" },
  ],
};
